module.exports = __webpack_public_path__ + "img/43_67.3a967f12.png";